<template>
  <div v-if="fileInfo && Object.keys(fileInfo).length > 0">
    <gf-files-list
      :files="fileInfo"
      :commits="filesCommits"
      :show-header="false"
      :has-reload="true"
      :branch-name="branch"
      :style="{ 'border-top': 'none', 'border-top-left-radius': 0, 'border-top-right-radius': 0 }"
    />
  </div>
  <div
    v-else-if="fileInfo && Object.keys(fileInfo).length === 0"
    class="repository__files-none py-2 px-3"
  >
    Нет файлов
  </div>
  <div v-else>
    <div class="position-relative p-4">
      <pacman-loader size="15" />
    </div>
  </div>
</template>

<script>
import RepoS from '@shared/services/repository.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import sharedComponentsMessages from '../sharedComponentsMessages';
import GfFilesList from './GfFilesList.vue';

export default {
  name: 'RepositoryFilesList',
  components: {
    PacmanLoader,
    GfFilesList
  },
  props: ['alias', 'model', 'branch'],
  data() {
    return {
      fileInfo: null,
      filesCommits: null,
      lastCommitInfo: null,
      isError: false,
      query: null
    };
  },
  computed: {
    userAlias() {
      return this.$store.getters.getUserAlias;
    }
  },
  mounted() {
    if (!window.lastCommitInfo) {
      window.lastCommitInfo = document.querySelector('#last-commit-getter').dataset.lastCommit;
    }
    this.lastCommitInfo = window.lastCommitInfo;

    this.query = this.$router.history.current.query;

    this.getFiles(this.query);
  },
  methods: {
    getFiles(params) {
      RepoS.getRepositoryFiles(this.model, this.alias, this.model, params).then((res) => {
        this.fileInfo = res;
        this.getCommits(params);
      });
    },
    getCommits(commitParams) {
      RepoS.getRepositoryFilesCommits(this.model, this.alias, this.model, this.lastCommitInfo, {
        filePath: encodeURIComponent(commitParams.file == null ? "" : commitParams.file)
      }).then((res) => {
        this.filesCommits = res;
      });
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>

<style lang="scss" scoped>
.repository {
  &__files-list {
    display: flex;
    position: relative;
    gap: 1rem;
    padding: 7px 1rem;

    > a:nth-child(2) {
      width: 50%;

      @media screen and (min-width: 992px) {
        width: 22%;
      }
    }

    > a:nth-child(3) {
      width: 100%;
      max-width: 45%;
    }

    > div:last-child {
      min-width: 140px;
      margin-left: auto;
    }
  }
  &__files-none {
    text-align: center;
    border: 1px solid var(--border-color);
    border-top: none;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }
}
</style>
